// import { isEmpty } from "../utils/tool";
import type { MonitorSdk, MonitorPlugin } from "../types/type";
import { parseStackFrames } from "../utils/parseErrorStk";
import md5 from "blueimp-md5";

// const getErrorUid = (input: Record<string, any>) => window.btoa(encodeURIComponent(JSON.stringify(input)));

export default class BrowserBase implements MonitorPlugin {
  init(sdk: MonitorSdk) {
    if (typeof window === 'undefined') return;

    const ignoreError: string[] = [];
    const stkLimit = 10;

    const errorCaches: string[] = [];

    const originError = window.onerror;
    //event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error
    window.onerror = function (...args) {
      if (args && args.length > 0 && ignoreError.includes(args[0] as string)) {
        console.warn("window.onerror", args);
        return;
      }
      // 调用原始方法
      if (originError) {
        originError(...args);
      }

      const [msg, url, line, column, error] = args;

      if (!msg && !url && !line && !column && !error) {
        // 无效错误, 其它方式捕获的错误
        return
      }

      const frames = parseStackFrames(error, stkLimit);

      const errorUid = md5(JSON.stringify(error?.stack || error)) as string;

      if (errorCaches.includes(errorUid)) {
        return;
      }
      errorCaches.push(errorUid);

      setTimeout(() => errorCaches.splice(errorCaches.indexOf(errorUid), 1), 25);

      sdk.report({
        module: "error",
        action: "js_error",
        target: [encodeURI(url || ''), line, column].join(":"),
        status: errorUid,
        logs: {
          msg,
          stack: frames
        },
      });

    };

    /**
     * 资源加载异常
     */
    window.addEventListener(
      "error",
      function (event) {
        const target: any = event.target || event.srcElement;
        const isScript = target instanceof HTMLScriptElement;
        const isLink = target instanceof HTMLLinkElement;
        const isImg = target instanceof HTMLImageElement;
        const isElementTarget = isScript || isLink || isImg;
        if (!isElementTarget) return false;

        const url = (target as any).src || (target as any).href;
        const type = isScript ? "script" : isLink ? "link" : isImg ? "img" : "other";

        const errorUid = md5(JSON.stringify({ url })) as string;

        sdk.report({
          module: "error",
          action: "resource_error",
          target: url,
          status: errorUid,
          logs: { url, type },
        });
      },
      true
    );


    /**
     * 未捕获Promise 异常
     */
    const originUnHandleRejection = window.onunhandledrejection;
    window.onunhandledrejection = function (error: PromiseRejectionEvent) {
      if (originUnHandleRejection) {
        originUnHandleRejection.call(window, error);
      }
      const reason = error.reason;

      let msg: string = '';
      if (typeof reason === 'string') {
        msg = reason;
      } else if (typeof reason === 'object' && reason.stack) {
        msg = reason.stack;
      }

      /* if (msg == 'TypeError: Failed to fetch') {
        // fetch 请求失败, 用fetch api 捕获
        return;
      } */

      const frames = parseStackFrames(reason, 10);

      const errorUid = md5(JSON.stringify(frames)) as string;

      const targetIndex = reason?.__monitor_stk_count__ || 0

      const frame = frames[targetIndex];
      const target = frame ? `${frame.file}:${frame.line}:${frame.col}` : msg;

      sdk.report({
        module: "error",
        action: "promise_error",
        target,
        status: errorUid,
        logs: {
          msg,
          stack: frames
        }
      })
    };


  }
}
